export { default } from "./BottomNavigation.js";
export { default as bottomNavigationClasses } from "./bottomNavigationClasses.js";
export * from "./bottomNavigationClasses.js";